import { render } from "./EventsDetail.vue?vue&type=template&id=62a68dfd"
import script from "./EventsDetail.vue?vue&type=script&lang=js"
export * from "./EventsDetail.vue?vue&type=script&lang=js"

import "./EventsDetail.vue?vue&type=style&index=0&id=62a68dfd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__